const video = {
  displayField: 'header',
  name: 'Video',
  description: 'Generic Video',
  fields: [
    {
      id: 'header',
      name: 'Title',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'video_source',
      name: 'YouTube or Self Hosted',
      type: 'Boolean',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'youTubeUrl',
      name: 'YouTube URL',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'videoUpload',
      name: 'Video Upload',
      type: 'Link',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'posterImage',
      name: 'Poster Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    }
  ],
  sys: { id: 'video', version: 24, updatedAt: '2023-07-18T20:39:48.458Z' }
};
export default video;